<template>
  <vs-popup
    class="popup"
    button-close-hidden
    v-bind="$attrs"
    v-on="$listeners"
  >
    <img
      class="vs-popup--close-button"
      :src="require('@/assets/shipo-popup-icon-close.svg')"
      @click="$emit('close')"
    >
    <img
      class="vs-popup--img"
      :src="require('@/assets/shipo-popup-icon-terminate.svg')"
    >
    <h3 class="vs-popup--content-title">
      Terminate Contract
    </h3>
    <p class="vs-popup--content-subtitle">
      Are you sure want to terminate this contract ?
    </p>
    <div class="mt-5 w-full flex flex-row justify-center items-center">
      <vs-button
        type="border"
        color="secondary"
        class="w-32 mr-2 font-semibold"
        @click="$emit('close')"
      >
        Cancel
      </vs-button>
      <vs-button
        type="filled"
        color="secondary"
        class="w-32 ml-2 font-semibold"
        @click="$emit('terminate')"
      >
        Terminate
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopUp'
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-auto;
    @apply rounded-2xl;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply relative;
      @apply p-12;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      @apply items-center;

      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }

      &-subtitle {
        @apply text-grey-001;
        @apply mt-8;
      }
    }

    &--img {
      width: 152px;
    }

    &--close-button {
      @apply cursor-pointer;
      @apply absolute;
      width: 35px;
      top: 1rem;
      right: 1rem;
    }

    &--ok {
      @apply rounded-xl;
      @apply mt-20;
      @apply py-4;
      @apply px-20;
      -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
      box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);

      &:focus {
        @apply outline-none;
        @apply border-none;
      }
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }
  }
}
</style>
